module.exports = __webpack_public_path__ + "static/media/icon_arrow_right.a67fd68b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/od-icons/icon_arrow_right.svg
// module id = 1053
// module chunks = 0